// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-lightColorTitle{font-weight:400}.c-description{font-size:.9rem}", ""]);
// Exports
module.exports = exports;
